import React from 'react';
import { useState, useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import Chevron from './../images/chevron.png';

import './success-failure.scss';
import Spinner from './../components/spinner';

import { firebaseAnalytics } from "../firebase";
import { logEvent } from 'firebase/analytics';

const Success = ({ completedTestExists, loading, user }) => {

    useEffect (()=> {
         // Log checkout initiation
      logEvent(firebaseAnalytics, 'begin_checkout', {
        currency: 'NZD',
        value: 12.00,
        items: [{
          item_name: 'Big Five Premium test',
        }]
      });
    })

    return (
        <div className="success-body">

            {(loading == true) ?
                <Spinner />
                :
                <>
                    {(!user) ? <> User not logged in </> :
                        <>
                            <h1> Success </h1>
                            Thank you for your purchase.
                            {completedTestExists ?
                                <>
                                    You can now view your premium results:
                                    <Link to="/results">
                                        <button className="button" >
                                            <div className="button-text" >  View results </div>
                                            <img className="button-icon" src={Chevron} alt="chevron" />
                                        </button>
                                    </Link>

                                </>

                                :

                                <>  Take the test to access your premium results:

                                    <Link to="/pre-test">
                                        <button className="button" >
                                            <div className="button-text" >  Begin test </div>
                                            <img className="button-icon" src={Chevron} alt="chevron" />
                                        </button>
                                    </Link>

                                </>


                            }

                        </>
                    }

                </>

            }
        </div >
    );
}



export default Success;
